import React, { useState, useEffect, useRef } from 'react';

const AddCategoryModal = ({ isOpen, onClose, onSave, editingCategory }) => {
  const [title, setTitle] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      if (editingCategory) {
        setTitle(editingCategory.title);
      } else {
        setTitle('');
      }
      setError('');
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
    }
  }, [editingCategory, isOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      } else if (event.key === 'Tab' && modalRef.current) {
        const focusableElements = Array.from(modalRef.current.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )).filter(el => el.offsetParent !== null);

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const currentIndex = focusableElements.indexOf(document.activeElement);

        event.preventDefault();

        if (event.shiftKey) {
          if (currentIndex <= 0) {
            lastElement.focus();
          } else {
            focusableElements[currentIndex - 1].focus();
          }
        } else {
          if (currentIndex === -1 || currentIndex === focusableElements.length - 1) {
            firstElement.focus();
          } else {
            focusableElements[currentIndex + 1].focus();
          }
        }
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, editingCategory, onClose]);

  if (!isOpen) return null;

  const handleSave = async (andAnother) => {
    if (!title) {
      setError('Category title cannot be empty');
      return;
    }
    const response = await onSave({ ...editingCategory, title }, andAnother);
    if (response && response.error) {
      setError(response.error);
    } else {
      setError('');
      if (andAnother) {
        setTitle('');
        inputRef.current.focus();
      } else {
        onClose();
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        <div className="modal-header">
          <h2><i className="material-icons" style={{ marginRight: '5px', verticalAlign: 'top' }}>widgets</i>{editingCategory ? 'Edit Category' : 'Add Category'}</h2>
          <button title="Close" onClick={onClose} className="icon-button close-button"><i className="material-icons">close</i></button>
        </div>
        <div className="modal-body">
        {error && <p className="error-message">{error}</p>}
        <div className="search-input-container">
          <input
            ref={inputRef}
            type="text"
            placeholder="Category Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSave(!editingCategory)}
          />
          {title && <button title="Clear title" onClick={() => { setTitle(''); inputRef.current.focus(); }} className="clear-input-button"><i className="material-icons">close</i></button>}
        </div>
        </div>
        <div className="modal-footer">
          {!editingCategory && <button title="Save and add another" onClick={() => handleSave(true)}>Save and another</button>}
          <button title="Save and close" onClick={() => handleSave(false)}>Save and close</button>
          <button title="Cancel" onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddCategoryModal;